import React from 'react'
import ScrollAnimation from 'react-animate-on-scroll'

const ScrollCascade = ({ children, ...props }) => (
  children.map((child, index) => (
    <ScrollAnimation key={index} {...props}>
      {child}
    </ScrollAnimation>
  ))
)

export default ScrollCascade;



// WEBPACK FOOTER //
// ./src/components/ScrollCascade.js